<template>
  <Info>
    <div>Seerist: {{ message }}</div>
    <div>
      <a href="/login">Login</a>
    </div>
  </Info>
</template>

<script>
import { ENDPOINT_ALERT_UNSUBSCRIBE } from "@/common/constants/api";
import { httpPost } from "@/services/api.service";

export default {
  name: "AlertUnsubscribe",
  components: {
    Info: () => import("@/components/auth/Info"),
  },
  async mounted() {
    await this.doUnsub();
  },
  data: () => ({
    message: "Attempting to unsubscribe from alert",
  }),
  methods: {
    doUnsub: async function () {
      if (this.$route && this.$route.params && this.$route.params.token) {
        try {
          let res = await httpPost({
            url: `${ENDPOINT_ALERT_UNSUBSCRIBE}/${this.$route.params.token}`,
            skipCheckAuth: true,
          });

          res = JSON.parse(res);

          if (res.data && res.data.message === "Unsuccessful") {
            this.message =
              "Failed to unsubscribe. It is possible you have already unsubscribed.";
          } else if (res.data && res.data.message === "Success") {
            this.message = "Successfuly Unsubscribed";
          } else {
            this.message = "Something went wrong unsubscribing";
          }
        } catch (err) {
          this.message = "Something went wrong unsubscribing";
        }
      } else {
        this.message = "Unsubscribe token missing from URL";
      }
    },
  },
};
</script>

<style scoped></style>
